import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

/**
 * GET Funciones Principales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFuncionesPrincipales = async (params) => {
  try {
    const response = await API.get('/nominas/solicitud-de-contratacion-funciones-principales', { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Funciones Principales
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncionPrincipal = async (values) => {
  try {
    const response = await API.post('/nominas/solicitud-de-contratacion-funciones-principales', values);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};

/**
 * PATCH Funciones Principales
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncionPrincipal = async (id, values) => {
  try {
    const response = await API.patch(`/nominas/solicitud-de-contratacion-funciones-principales/${id}/`, values);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};

/**
 * DELETE Funciones Principales
 * @param {number} id
 * @param {object} values
 * @param {boolean} [isSoftDelete=false]
 * @returns {Promise<object|boolean>}
 */
export const deleteFuncionPrincipal = async (id) => {
  try {
    const response = await API.delete(`/nominas/solicitud-de-contratacion-funciones-principales/${id}/`);
    return onSuccess(response);
  } catch (error) {
    return onError(error);
  }
};
